import ArchivePageTitle from './ArchivePageTitle';

export default ArchivePageTitle;
